import React from 'react'
import { FlexHorizontal, LoadMask, Spacer, useToasts } from '@vestaboard/installables'
import { useCreateColorTemplate, useCreateTemplateMessage } from '../hooks/useCreateColorTemplate'
import { ColorTemplateForm } from '../components/ColorTemplateForm'
import { Typography } from '@material-ui/core'
import { useHistory } from 'react-router'

export const CreateColorTemplate = () => {
  const [createColorTemplate, { loading: savingCategory }] = useCreateColorTemplate()
  const [createTemplateMessage, { loading: savingMessages }] = useCreateTemplateMessage()
  const { addToast } = useToasts()
  const history = useHistory()

  return (
    <>
      {savingCategory || savingMessages ? <LoadMask /> : null}
      <FlexHorizontal spaceBetween>
        <Typography variant='h4'>Create Color Template</Typography>
      </FlexHorizontal>
      <Spacer size='large' />
      <ColorTemplateForm
        onSave={async input => {
          const response = await createColorTemplate({
            variables: {
              input: {
                title: input.title
              }
            }
          })

          if (response.data?.createColorTemplate?.__typename === 'TemplateCategoryV2') {
            const categoryId = response.data.createColorTemplate.id
            const messageResults = await Promise.all(
              (input.messages || []).map(message =>
                createTemplateMessage({
                  variables: {
                    input: {
                      categoryId,
                      messageId: message.id
                    }
                  }
                })
              )
            )
            const failed = messageResults.filter(
              r => r.data?.createTemplateMessageV2.__typename !== 'TemplateMessageV2'
            )
            if (failed.length > 0) {
              addToast(`Color template created but ${failed.length} message(s) could not be added`, {
                appearance: 'error',
                autoDismiss: true
              })
            } else {
              history.push(`/color-templates/${categoryId}`)
            }
          } else {
            addToast(response?.data?.createColorTemplate?.error || 'There was an error creating your color template', {
              appearance: 'error',
              autoDismiss: true
            })
          }
        }}
      />
    </>
  )
}
